'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

// Компонент SVG с анимацией для desktop версии
function DesktopIllustration() {
	return (
		<svg className={styles.desktopImage} width="1110" height="330" viewBox="0 0 1110 330" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: 'visible' }}>
			<defs>
				{/* Траектории движения для точек по окружностям */}
				{/* Точка 1: (190.5, 222.5) - малый круг (241.5, 166.5) r=77.5 */}
				<path
					id="path1"
					d="M 190.5 220.5 A 71.5 71.5 0 1 1 292.5 110.5 A 71.5 71.5 0 1 1 190.5 220.5"
					fill="none"
					stroke="none"
				/>
				{/* Точка 2: (405.5, 16.5) - большой розовый круг (482, 165) r=164 */}
				<path
					id="path2"
					d="M 405.5 16.5 A 164 164 0 1 1 558.5 313.5 A 164 164 0 1 1 405.5 16.5"
					fill="none"
					stroke="none"
				/>
				{/* Точка 3: (644.5, 162.5) - эллипс (599, 165.5) */}
				<path
					id="path3"
					d="M 639.5 160.5 A 43 47 0 1 1 553.5 165.5 A 43 47 0 1 1 639.5 160.5"
					fill="none"
					stroke="none"
				/>
				{/* Точка 4: (831.5, 247.5) - второй розовый круг (758, 166) r=113 */}
				<path
					id="path4"
					d="M 831.5 247.5 A 109.75 109.75 0 1 1 684.5 84.5 A 109.75 109.75 0 1 1 831.5 247.5"
					fill="none"
					stroke="none"
				/>
				{/* Точка 5: (942.5, 165.5) - серый круг (977, 166) r=106 */}
				<path
					id="path5"
					d="M 871 166 A 106 106 0 1 1 1083 166 A 106 106 0 1 1 871 166"
					fill="none"
					stroke="none"
				/>
				<clipPath id="clip0_3439_3976">
					<rect width="1110" height="330" fill="white"/>
				</clipPath>
				<clipPath id="clip1_3439_3976">
					<rect width="1110" height="1166" fill="white"/>
				</clipPath>
			</defs>
			
			{/* Круги - сначала рисуем все круги */}
			<g clipPath="url(#clip0_3439_3976)">
				<rect width="1110" height="330" fill="#151515"/>
				<g clipPath="url(#clip1_3439_3976)">
					<rect width="1110" height="1166" fill="#151515"/>
					<rect width="1110" height="330" transform="translate(-3)" fill="#151515"/>
					<circle cx="482" cy="165" r="164.5" stroke="#7A7A7A"/>
					<circle cx="241.5" cy="166.5" r="77.5" stroke="#7A7A7A" strokeWidth="2"/>
					<circle cx="977" cy="166" r="106" stroke="#7A7A7A" strokeWidth="2"/>
					<circle cx="170" cy="169" r="149" stroke="#7A7A7A" strokeWidth="2"/>
					<circle cx="794" cy="163" r="149" stroke="#7A7A7A" strokeWidth="2"/>
					<path d="M599 119C624.967 119 646 139.829 646 165.5C646 191.171 624.967 212 599 212C573.033 212 552 191.171 552 165.5C552 139.829 573.033 119 599 119Z" stroke="#7A7A7A" strokeWidth="2"/>
					<circle cx="435" cy="165" r="117" stroke="#7A7A7A" strokeWidth="2"/>
					<circle cx="482" cy="165" r="164" stroke="#F23B67" strokeWidth="2"/>
					<circle cx="758" cy="166" r="113" stroke="#F23B67" strokeWidth="2"/>
				</g>
			</g>
			
			{/* Анимированные точки - рисуем после кругов для правильного z-index */}
			<circle r="8.5" fill="white">
				<animateMotion dur="4s" repeatCount="indefinite">
					<mpath href="#path1" />
				</animateMotion>
			</circle>
			{/* Вторая точка - без clipPath чтобы могла выходить за пределы */}
			<g clipPath="none">
				<circle r="8.5" fill="white">
					<animateMotion dur="7s" repeatCount="indefinite">
						<mpath href="#path2" />
					</animateMotion>
				</circle>
			</g>
			<circle r="8.5" fill="white">
				<animateMotion dur="3s" repeatCount="indefinite">
					<mpath href="#path3" />
				</animateMotion>
			</circle>
			<circle r="8.5" fill="white">
				<animateMotion dur="6s" repeatCount="indefinite">
					<mpath href="#path4" />
				</animateMotion>
			</circle>
			<circle r="8.5" fill="white">
				<animateMotion dur="6s" repeatCount="indefinite">
					<mpath href="#path5" />
				</animateMotion>
			</circle>
		</svg>
	)
}

// Компонент SVG с анимацией для tablet версии
function TabletIllustration() {
	return (
		<svg className={styles.tabletImage} width="680" height="217" viewBox="0 0 680 217" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: 'visible' }}>
			<defs>
				{/* Траектории движения для точек по окружностям */}
				{/* Точка 1: (110, 146) - малый круг (96, 111) r=95 */}
				<path
					id="tablet-path1"
					d="M 110 146 A 48.2 48.2 0 1 1 173 73 A 48.2 48.2 0 1 1 110 146"
					fill="none"
					stroke="none"
				/>
				{/* Точка 2: (247, 14) - большой розовый круг (295.5, 108.5) r=104.5 */}
				<path
					id="tablet-path2"
					d="M 247 14 A 104.5 104.5 0 1 1 344 203 A 104.5 104.5 0 1 1 247 14"
					fill="none"
					stroke="none"
				/>
				{/* Точка 3: (400, 107) - эллипс (370, 108.5) */}
				<path
					id="tablet-path3"
					d="M 400 107 A 30 30 0 1 1 340 108.5 A 30 30 0 1 1 400 107"
					fill="none"
					stroke="none"
				/>
				{/* Точка 4: (519, 162) - второй розовый круг (472, 109) r=72 */}
				<path
					id="tablet-path4"
					d="M 519 162 A 70.8 70.8 0 1 1 425 56 A 70.8 70.8 0 1 1 519 162"
					fill="none"
					stroke="none"
				/>
				{/* Точка 5: (590, 109) - эллипс (611.5, 109) */}
				<path
					id="tablet-path5"
					d="M 611.5 42 C 648.786 42 679 72.0038 679 109 C 679 145.996 648.786 176 611.5 176 C 574.214 176 544 145.996 544 109 C 544 72.0038 574.214 42 611.5 42 Z"
					fill="none"
					stroke="none"
				/>
			</defs>
			
			{/* Круги - сначала рисуем все круги */}
			<rect width="680" height="217" fill="#151515"/>
			<circle cx="295.5" cy="108.5" r="105" stroke="#7A7A7A"/>
			<circle cx="141.5" cy="109.5" r="49.5" stroke="#7A7A7A" strokeWidth="2"/>
			<path d="M611.5 42C648.786 42 679 72.0038 679 109C679 145.996 648.786 176 611.5 176C574.214 176 544 145.996 544 109C544 72.0038 574.214 42 611.5 42Z" stroke="#7A7A7A" strokeWidth="2"/>
			<circle cx="96" cy="111" r="95" stroke="#7A7A7A" strokeWidth="2"/>
			<circle cx="495" cy="107" r="95" stroke="#7A7A7A" strokeWidth="2"/>
			<path d="M370 79C386.584 79 400 92.2229 400 108.5C400 124.777 386.584 138 370 138C353.416 138 340 124.777 340 108.5C340 92.2229 353.416 79 370 79Z" stroke="#7A7A7A" strokeWidth="2"/>
			<circle cx="265.5" cy="108.5" r="74.5" stroke="#7A7A7A" strokeWidth="2"/>
			<circle cx="295.5" cy="108.5" r="104.5" stroke="#F23B67" strokeWidth="2"/>
			<circle cx="472" cy="109" r="72" stroke="#F23B67" strokeWidth="2"/>
			
			{/* Анимированные точки - рисуем после кругов для правильного z-index */}
			<circle r="6" fill="white">
				<animateMotion dur="3s" repeatCount="indefinite">
					<mpath href="#tablet-path1" />
				</animateMotion>
			</circle>
			<g clipPath="none">
				<circle r="6" fill="white">
					<animateMotion dur="7s" repeatCount="indefinite">
						<mpath href="#tablet-path2" />
					</animateMotion>
				</circle>
			</g>
			<circle r="6" fill="white">
				<animateMotion dur="3s" repeatCount="indefinite">
					<mpath href="#tablet-path3" />
				</animateMotion>
			</circle>
			<circle r="6" fill="white">
				<animateMotion dur="5s" repeatCount="indefinite">
					<mpath href="#tablet-path4" />
				</animateMotion>
			</circle>
			<circle r="6" fill="white">
				<animateMotion dur="5s" repeatCount="indefinite">
					<mpath href="#tablet-path5" />
				</animateMotion>
			</circle>
		</svg>
	)
}

function MobileIllustration() {
	return (
		<svg className={styles.mobileImage} width="328" height="127" viewBox="0 0 328 127" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ overflow: 'visible' }}>
			<defs>
				{/* Траектории движения для точек по окружностям */}
				<path
					id="mobile-path1"
					d="M 66.129 86.232 A 20.3 20.3 0 1 1 102.2 40.7 A 20.3 20.3 0 1 1 66.129 86.232"
					fill="none"
					stroke="none"
				/>
				<path
					id="mobile-path2"
					d="M 148.658 6.87754 A 50 50 0 1 1 206.8 120 A 50 50 0 1 1 148.658 6.87754"
					fill="none"
					stroke="none"
				/>
				<path
					id="mobile-path3"
					d="M 240.709 62.9547 A 43.4 43.4 0 1 1 327.5 64 A 43.4 43.4 0 1 1 240.709 62.9547"
					fill="none"
					stroke="none"
				/>
				<path
					id="mobile-path4"
					d="M222.724 45.9966C232.673 45.9968 240.739 54.0633 240.739 64.0132C240.739 73.9628 232.673 82.0286 222.724 82.0288C212.774 82.0288 204.707 73.963 204.707 64.0132C204.707 54.0631 212.774 45.9966 222.724 45.9966Z"
					fill="none"
					stroke="none"
				/>
			</defs>
			
			{/* Круги - сначала рисуем все круги */}
			<rect width="328" height="127" fill="#151515"/>
			<path d="M177.755 0.5C212.54 0.5 240.739 28.6986 240.739 63.4834C240.739 98.2684 212.54 126.468 177.755 126.468C142.97 126.468 114.771 98.2683 114.771 63.4834C114.772 28.6987 142.97 0.500256 177.755 0.5Z" stroke="#7A7A7A"/>
			<path d="M85.1746 34.3579C101.552 34.3581 114.829 47.6354 114.829 64.0132C114.829 80.3908 101.552 93.6672 85.1746 93.6675C68.7968 93.6675 55.5195 80.3909 55.5193 64.0132C55.5193 47.6353 68.7966 34.3579 85.1746 34.3579Z" stroke="#7A7A7A"/>
			<circle cx="284.089" cy="64.0127" r="43.4097" stroke="#7A7A7A"/>
			<path d="M57.6641 7.90625C89.235 7.90625 114.829 33.4994 114.829 65.0703C114.829 96.6414 89.2352 122.235 57.6641 122.235C26.0932 122.235 0.5 96.6413 0.5 65.0703C0.500247 33.4996 26.0933 7.9065 57.6641 7.90625Z" stroke="#7A7A7A"/>
			<path d="M222.724 45.9966C232.673 45.9968 240.739 54.0633 240.739 64.0132C240.739 73.9628 232.673 82.0286 222.724 82.0288C212.774 82.0288 204.707 73.963 204.707 64.0132C204.707 54.0631 212.774 45.9966 222.724 45.9966Z" stroke="#7A7A7A"/>
			<path d="M159.769 18.4873C184.619 18.4875 204.765 38.6334 204.765 63.4844C204.764 88.3352 184.619 108.48 159.769 108.48C134.918 108.48 114.772 88.3353 114.771 63.4844C114.771 38.6333 134.918 18.4873 159.769 18.4873Z" stroke="#7A7A7A"/>
			<path d="M177.755 0.5C212.54 0.5 240.739 28.6986 240.739 63.4834C240.739 98.2684 212.54 126.468 177.755 126.468C142.97 126.468 114.771 98.2683 114.771 63.4834C114.772 28.6987 142.97 0.500256 177.755 0.5Z" stroke="#F23B67"/>
			
			{/* Анимированные точки - рисуем после кругов */}
			<ellipse rx="3.70323" ry="3.70323" fill="white">
				<animateMotion dur="5s" repeatCount="indefinite">
					<mpath href="#mobile-path1" />
				</animateMotion>
			</ellipse>
			<ellipse rx="3.70323" ry="3.70323" fill="white">
				<animateMotion dur="6s" repeatCount="indefinite">
					<mpath href="#mobile-path2" />
				</animateMotion>
			</ellipse>
			<ellipse rx="3.70323" ry="3.70323" fill="white">
				<animateMotion dur="4s" repeatCount="indefinite">
					<mpath href="#mobile-path3" />
				</animateMotion>
			</ellipse>
			<ellipse rx="3.70323" ry="3.70323" fill="white">
				<animateMotion dur="3s" repeatCount="indefinite">
					<mpath href="#mobile-path4" />
				</animateMotion>
			</ellipse>
		</svg>
	)
}

const Main: React.FC = () => {
	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.content}>
					<Typography variant='h1' className={styles.title}>
						Комплексные решения
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
						Реализуем масштабные ИТ-проекты «под ключ» для корпораций и госсектора. Берём на себя весь цикл создания цифровых экосистем: от глубокой аналитики и проектирования архитектуры до внедрения, сопровождения и развития.
					</Typography>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<div className={styles.imageContainer}>
					<DesktopIllustration />
					<TabletIllustration />
					<MobileIllustration />
				</div>
			</AnimatedSection>
		</section>
	)
}

Main.displayName = 'Main'

export default Main